import { FormGroup, Validators } from '@angular/forms';
import { FamilyMemberFormBuilder } from '../../../../family-member/form-group/family-member.form.builder';
import { FamilyMemberFormModel } from '../../../../family-member/form-group/family-member-form.model';
import { BeneficiaryDetailsFormModel } from '../../../../../shared/components/beneficiary/form-beneficiary-details/form-group/beneficiary-details-form.model';
import { AddressFormBuilder } from '../../../../../shared/components/address/form-address/form-group/address.form.builder';
import { CzlonekRodziny } from '../../../../../shared/models/czlonek-rodziny';
import { RodzajDokumentu } from '../../../../../shared/enums/rodzaj-dokumentu.enum';
import { DowodOsobistyValidator } from '../../../../../shared/validators/dowod-osobisty.validator';
import { PeselUtils } from '../../../../../shared/utils/pesel.utils';
import { DateUtils } from '../../../../../shared/utils/date.utils';

// Prepares a separate form for the table without mounting or changing the editor.
export class FamilyMemberValidationFormBuilder {
  public static createFormGroup(
    member: CzlonekRodziny,
  ): FormGroup<FamilyMemberFormModel> {
    const fg = FamilyMemberFormBuilder.createFormGroup(member);
    this.#initializeDetails(fg.controls.details);
    AddressFormBuilder.switchDomesticOrForeignGroup(fg.controls.address, true);
    this.#initializeSchool(fg);
    return fg;
  }

  static #initializeDetails(fg: FormGroup<BeneficiaryDetailsFormModel>): void {
    const decodedPesel = PeselUtils.decode(fg.controls.pesel.value);
    if (decodedPesel.isValid && decodedPesel.birthDate) {
      const date = decodedPesel.birthDate;
      const timeDifference = date.getTimezoneOffset();
      date.setHours(0, 0, 0, 0);
      fg.controls.dataUrodzenia.setValue(
        new Date(date.setMinutes(-timeDifference)),
      );
      fg.controls.dataUrodzenia.disable();
    }

    // Match the editor's document validators and its input maxlength.
    const { nrDokumentu, rodzajDokumentu } = fg.controls;
    nrDokumentu.setValidators(Validators.maxLength(25));
    if (rodzajDokumentu.value) {
      nrDokumentu.addValidators(Validators.required);
    }
    if (rodzajDokumentu.value === RodzajDokumentu.DOWOD_OSOBISTY) {
      nrDokumentu.addValidators(
        DowodOsobistyValidator.validNumberDokumentuTozsamosci,
      );
    }
    rodzajDokumentu.setValidators(
      nrDokumentu.value ? Validators.required : null,
    );
    nrDokumentu.updateValueAndValidity();
    rodzajDokumentu.updateValueAndValidity();
  }

  static #initializeSchool(fg: FormGroup<FamilyMemberFormModel>): void {
    const school = fg.controls.school;
    const age = DateUtils.calculateAge(
      fg.controls.details.controls.dataUrodzenia.value,
    );
    if (age < 0 || age > 26) {
      school.controls.isDaneSzkoly.reset();
      school.controls.isDaneSzkoly.disable();
    }
    if (school.controls.isDaneSzkoly.value) {
      AddressFormBuilder.switchDomesticOrForeignGroup(
        school.controls.adres,
        true,
      );
    } else {
      school.controls.nazwa.disable();
      school.controls.rodzaj.disable();
      school.controls.adres.disable();
    }
  }
}
